import { clamp } from 'lodash';

export const getFcoseForceValues = (nodeCount: number) => {
  const count = Number.isFinite(nodeCount) && nodeCount > 0 ? nodeCount : 0;

  return {
    nodeRepulsion: clamp(count * 20, 2000, 20000),
    idealEdgeLength: clamp(count / 4, 100, 2000),
    edgeElasticity: 0.6,
  };
};

export const GRAPH_LAYOUT_CONFIG_FCOSE = {
  name: 'fcose',

  quality: 'default',
  randomize: true,
  animate: false,

  fit: true,
  padding: 100,

  packComponents: true,

  // critical
  nodeDimensionsIncludeLabels: false,
  uniformNodeDimensions: false,

  // prevents node touching
  nodeSeparation: 250,

  ...getFcoseForceValues(0),

  // moderate gravity only
  gravity: 0.8,
  // gravityCompound: 1.0,
  // gravityRange: 3.8,
  // gravityRangeCompound: 1.5,

  // helps untangle large graphs
  nestingFactor: 10.2,

  // IMPORTANT for large graphs
  numIter: 500,

  // usually better for large connected graphs
  tile: false,

  samplingType: true,
  sampleSize: 50,

  initialEnergyOnIncremental: 0.3,
};
